export const groupsApi = '/api/v1/users/customgroups/';
